import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { JhiEventManager, JhiParseLinks } from 'ng-jhipster';
import { isNullOrUndefined, isUndefined } from 'util';

import { Account, ResponseWrapper, User } from '../../../models';
import { UserService, Principal } from '../../../services';
import { checkIfCanDelete, checkIfCanEdit } from '../../../shared';
import { ITEMS_PER_PAGE, ROLE_PREFIX, USER_LIST_MODIFICATION } from '../../../shared/constants';
import { HumanAuthorities } from '../../../shared/enums';

@Component({
    selector: 'qms-users',
    templateUrl: './users.component.html'
})
export class UsersComponent implements OnInit, OnDestroy {

    private currentAccount: Account;

    public users: User[];
    public role: string;
    public accessDenied: boolean;
    private authority: string;

    private routeDataSubscription: Subscription;
    private routerSubscription: Subscription;
    private userSubscription: Subscription;

    public totalItems: number;
    public queryCount: any;
    public itemsPerPage: number;
    public page: number;
    public predicate: any;
    public reverse: string;

    private previousPage: any;
    private links: any;

    constructor(private userService: UserService,
                private parseLinks: JhiParseLinks,
                private principal: Principal,
                private eventManager: JhiEventManager,
                private activatedRoute: ActivatedRoute,
                private router: Router) {
        this.accessDenied = false;
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeDataSubscription = this.activatedRoute.data.subscribe((data: any) => {
            this.page = data['pagingParams'].page;
            this.previousPage = data['pagingParams'].page;
            this.reverse = data['pagingParams'].ascending;
            this.predicate = data['pagingParams'].predicate;
            this.routerSubscription = this.activatedRoute.params.subscribe((params: any) => {
                this.accessDenied = false;
                this.role = data['role'];
                this.authority = this.roleToAuthority(this.role);
                if (!isUndefined(HumanAuthorities[this.authority])) {
                    this.loadAll();
                } else {
                    this.accessDenied = true;
                    this.users = null;
                }
            });
        });
    }

    ngOnInit() {
        this.principal.identity().then((account: Account) => {
            this.currentAccount = account;
            this.registerChangeInUsers();
        });
    }

    ngOnDestroy() {
        this.routeDataSubscription.unsubscribe();
        this.routerSubscription.unsubscribe();
        this.userSubscription.unsubscribe();
    }

    private registerChangeInUsers() {
        this.userSubscription = this.eventManager.subscribe(USER_LIST_MODIFICATION, () => this.loadAll());
    }

    private loadAll() {
        const serverRole = this.authority;
        this.users = null;
        this.userService.queryByRole(serverRole, {
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe((response: ResponseWrapper) => {
            this.onSuccess(response.json, response.headers);
        });
    }

    public trackIdentity(index: number, item: User) {
        return item.id;
    }

    public sort(): string[] {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    public loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    public transition() {
        this.router.navigate(['/management/users/', this.role], {
            queryParams: {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    }

    private onSuccess(data: User[], headers: any) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        this.users = data;
    }

    private roleToAuthority(role: string): string {
        return ROLE_PREFIX + role.toUpperCase();
    }

    public canDelete(user: User): boolean {
        return checkIfCanDelete(user, this.currentAccount);
    }

    public canEdit(user: User): boolean {
        return checkIfCanEdit(user, this.currentAccount);
    }

    public isLoggedUser(user: User): boolean {
        if (isNullOrUndefined(user) || isNullOrUndefined(this.currentAccount)) {
            return false;
        }
        return (user.login === this.currentAccount.login);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/users/users.component.ts